import styled from 'styled-components';
import { mq, getSpace, getGridSpans, getGridSpan } from '../../../../stylesheets/tools';

const StyledEducationTabletTemplate = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .copy-container {
    p {
      margin: ${getSpace('m')} 0;
      ${getGridSpans('width', { s: 12, m: 9 })}

      ${mq('m')} {
        margin: ${getSpace('m')} ${getGridSpan('2', 'spread')};
      }
    }
  }
`;

export default StyledEducationTabletTemplate;
